import templateStr from 'text!./psa-mini-policy-change.html';

export default [() => {
    return {
        restrict: 'EA',
        template: templateStr,
        scope: {
            vehicle: '=',
            onProceed: '='
        },
        controller: ['$scope', 'ViewModelService', ($scope, ViewModelService) => {
            // mapping between CoveredVehicleDTO_PSA and VehicleDTO_PSA
            const _vehicle = {
                license: $scope.vehicle.licensePlate,
                vin: $scope.vehicle.vin,
                //UCWAR-800
                producerCodeCountry: $scope.vehicle.producerCodeCountry
            };
            $scope.vehicleVm = ViewModelService.create(_vehicle, 'pc', 'psa.edge.capabilities.policyjob.lob.puw.coverables.dto.VehicleDTO_PSA');

            $scope.continue = (form) => {
                form.submitted = true;
                if (form.valid === false) {
                    return;
                }

                $scope.$parent.$dismiss();
                $scope.onProceed($scope.vehicleVm.value);
            };

            $scope.back = () => {
                $scope.$parent.$dismiss();
            };

        }]
    };
}];